import angular from 'angular';
import TooltipWrapperComponent from './tooltip-wrapper.ng1.component';

export default angular
    .module('control-room.commons.basic.components.tooltip-wrapper', [])
    .component('crTooltipWrapper', TooltipWrapperComponent);
